var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import { getOwner } from '@ember/application';
import * as Sentry from '@sentry/browser';
const LOCALHOST_DEV_PORT = '5173';
const DEV_MODE_MANIFEST_PATH = '/api/dashboard-spa-manifest';
const PROD_MODE_MANIFEST_PATH = '/shared-react-mfe/api/dashboard-spa-manifest';
let SharedMfe = (_class = class SharedMfe extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "environment", _descriptor, this);
    _defineProperty(this, "cachedManifest", undefined);
  }
  get config() {
    return getOwner(this).resolveRegistration('config:environment');
  }
  get useLocalIntegration() {
    return this.config.dashboardMFE?.['shared-mfe']?.enabled;
  }
  get manifest() {
    if (this.cachedManifest) {
      return this.cachedManifest;
    }
    return this.loadManifest();
  }
  async preloadApp(signal) {
    const app = await this.manifest;
    const modulesToPreload = app.moduleList;
    try {
      const promises = modulesToPreload.map(moduleToPreload => fetch(`${app.cdnOrigin}/${moduleToPreload}`, {
        signal
      }));
      await Promise.all(promises);
    } catch (e) {
      if (!signal.aborted) {
        Sentry.captureException(e);
      }
    }
  }
  async loadManifest() {
    const {
      isProduction,
      isSandbox,
      isStaging
    } = this.environment;
    if (isProduction || isSandbox) {
      return this.fetchManifest(`https://app.squareup.com${PROD_MODE_MANIFEST_PATH}`);
    }
    if (isStaging) {
      return this.fetchManifest(`https://app.squareupstaging.com${PROD_MODE_MANIFEST_PATH}`);
    }
    try {
      // see if we can load the local version to use by default, if it fails
      // fall back to loading the staging version
      const manifest = await this.fetchManifest(`http://localhost:${LOCALHOST_DEV_PORT}${DEV_MODE_MANIFEST_PATH}`, false);
      return manifest;
    } catch {
      return this.fetchManifest(`https://app.squareupstaging.com${PROD_MODE_MANIFEST_PATH}`);
    }
  }
  async fetchManifest(manifestEndpoint, log = true) {
    const response = await fetch(manifestEndpoint).then(res => {
      if (res.ok) {
        return res.json();
      }
      throw new Error(`Failed to load manifest: ${res.status}`);
    }).catch(e => {
      if (log) {
        Sentry.captureException(e);
      }
    });
    const {
      app
    } = response;
    this.cachedManifest = app;
    return app;
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "environment", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { SharedMfe as default };